
        import 'DragScope.28b6f79.css-module'
        export default {"DragPane":"DragPane_DragScope_28b6f79"}
    